export default {"src":"/_next/static/image/public/images/flags/flag_591.1baa209b32134203b7aee461cee9f772.svg","height":16,"width":24};